import TrackerGrid from "@/components/TrackerGrid";

const COLS = [
  { key: "ref_code", label: "Ref Code", type: "text", width: 160 },
  { key: "guest_name", label: "Guest Name", type: "text" },
  { key: "visit_date", label: "Visit Date", type: "text", width: 110 },
  { key: "visit_time", label: "Visit Time", type: "text", width: 80 },
  { key: "to_date", label: "To Date", type: "text", width: 110 },
  { key: "applicant_name", label: "Applicant", type: "text" },
  { key: "status", label: "Status", type: "select",
    options: ["In Progress", "Approved", "Completed", "Rejected", "On Hold"] },
  { key: "current_stage", label: "Current Stage", type: "text" },
  { key: "submitted_at", label: "Submitted At", type: "text", width: 160 },
];

export default function GuestTrackerPage() {
  return (
    <TrackerGrid
      endpoint="/analytics/guest-tracker"
      exportPath="/analytics/guest-tracker/export.xlsx"
      heading="Guest Visit Tracker"
      columns={COLS}
      dateRangeKey="visit_date"
    />
  );
}
